import { ao as v, ap as c, a as S, m as g, u as y, o as M, b as V, c as d, e as f, t as b, k as $, z as B, aC as k, g as q, j as C, G as I, x as h, n as w, an as R } from "./define-element-XpjsV6s1.js";
import { i as m } from "./utils-CMsllPx8.js";
import { _ as z } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = ["aria-invalid"], D = {
  __name: "Select",
  props: /* @__PURE__ */ R({
    floating: {
      type: Boolean,
      default: !1
    },
    invalid: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(s) {
    const a = v(s, "modelValue"), o = "select-" + Math.random().toString(36).substring(2), l = s, p = c(), n = S(!1), r = g(() => l.invalid && m(a.value) ? !1 : n.value && p.required != null ? !m(a.value) : !0), i = y("container");
    return M(() => {
      if (V(i.value), a.value === void 0) {
        const e = i.value.querySelector("option");
        a.value = e ? e.value : null;
      }
    }), (e, t) => (d(), f("div", {
      ref: "container",
      class: w([
        "offset-select",
        e.$attrs.required ? "required" : "",
        r.value ? "" : "invalid",
        l.floating ? "floating" : ""
      ])
    }, [
      e.$attrs.label ? (d(), f("label", {
        key: 0,
        for: o
      }, b(e.$attrs.label), 1)) : $("", !0),
      B(q("select", I(e.$attrs, {
        "onUpdate:modelValue": t[0] || (t[0] = (u) => a.value = u),
        id: o,
        "aria-invalid": !r.value,
        onInput: t[1] || (t[1] = h((u) => n.value = !0, ["stop"]))
      }), [
        C(e.$slots, "default", {}, void 0, !0)
      ], 16, A), [
        [k, a.value]
      ])
    ], 2));
  }
}, _ = /* @__PURE__ */ z(D, [["__scopeId", "data-v-0ef2fb44"]]);
export {
  _ as S
};
